import styled from 'styled-components'
import Icon from '@mdi/react'
import { respondAbove } from 'styles/mixins'
import TypographyPro from 'themes/TypographyPro'
import { ArrowBackIos as ArrowBackIcon, Favorite } from '@material-ui/icons'
import TextField from 'components/common/TextField'
import { mdiCrosshairsGps } from '@mdi/js'

export const CurrentLocationIcon = () => <Icon path={mdiCrosshairsGps} size="20px" color="var(--strokeMenuTitle)" />

export const CurrentLocationIconContainer = styled.div`
	width: 20px;
	height: 20px;
	cursor: pointer;
`

export const Container = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 20px 20px 0px 20px;
	gap: 28px;
  max-width: 100%;

	${respondAbove.sm`
		padding: 28px 28px 0px 28px;
	`}
`

export const StyledAddressSelectorContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
`

export const StyledAddressSelectorBody = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	align-self: stretch;
`

export const StyledHeaderTypography = styled(TypographyPro)`
	color: var(--strokeMenuTitle);
`

export const StyledPlaceTypography = styled(TypographyPro)`
	text-transform: uppercase;
	display: flex;
	padding: 8px 16px;
	justify-content: center;
	align-items: center;
	gap: 4px;
	color: var(--primary);
`

export const StyledEditAddressContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
`

export const StyledEditAddressBody = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 4px;
	align-self: stretch;
`

export const StyledInput = styled(TextField)`
	& .MuiOutlinedInput-notchedOutline {
		border: var(--stroke-1, 1px) solid var(--grey-var-inactive, #808080);
	}
`

export const StyledWrapper = styled.div`
	width: 100%;
`

export const StyledButtonsContainer = styled.div`
	display: flex;
	padding-top: 28px;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	align-self: stretch;
`

export const StyledHeartIcon = styled(Favorite)`
	width: 1.5rem;
	height: 1.5rem;
	padding-right: 0.5rem;
`

export const StyledLocationOnMap = styled.div`
	cursor: pointer;
`

export const StyledBackIcon = styled(ArrowBackIcon)`
	cursor: pointer;
	color: var(--inactive);
	font-size: 15px;
`
